module.exports = __webpack_public_path__ + "img/heavy_railgun.af20a43b.jpg";